import $ from 'jquery';
import cookie from 'react-cookies';
import * as globalUtils from '../../Global/global_js';
import * as PlayerUtils from '../js/index';
import * as PlayerIndexUtils from '../index_functions';
import * as playerDesignUtils from '../js/playerPageDesignSettings';
var video_guid = "";
var video_type = "";
var dv_account_guid = "";
var error_info = "";
var token_expire_time = '';
var video_token = "";
var token_guid = '';
var ticket_expire_date = '';
var valid_token = "false";
var visitor_ip = "";
var visitor_token;
var video_info;
var ticket_used = "false";
var token_flag = "";


export function get_account_payment_data(t)
{
    //error_info = "account_guid=" + t.props.videoData.userGuid + "&video_guid=" + t.props.videoData.videoGuid;
    //video_guid = t.props.videoData.videoGuid;
    debugger
    if (video_guid !== "" && video_guid !== undefined && video_guid !== null)
    {
        var api_link = localStorage.getItem("api_url") + "get_account_paypal_data";
        var parameters = {
            vod_guid: video_guid,
            vod_type: video_type,
        };

        $.ajax({
            type: "POST",
            url: api_link,
            data: parameters,
            async: false,
            dataType: "json",
            success: function (response)
            { get_account_payment_data_success(t, response) },
            error: get_account_payment_data_error

        });
    }

}
function get_account_payment_data_success(t, response)
{
    debugger;
    if (response !== null && response !== undefined)
    {
        t.setState({ paymentInfo: response })
    }

}
function get_account_payment_data_error(ex)
{
    debugger;
}


export function insert_ticket_order(t)
{
    try
    {
        var money = t.state.downloadVideoPrice;
        var selected_tickets = t.state.selectedTicket.id + "_1";
        var money_selected = parseInt(money);
        if (money != "" && selected_tickets != "" && money_selected < 501)
        {
            var api_link = localStorage.getItem("api_url") + "insert_ticket_order";
            var parameters = {
                order_items: selected_tickets,
                total_money: money,
                email: "",
                video_guid: t.props.videoData.videoGuid,
                account_guid: t.props.videoData.userGuid,
                error_info: error_info + "&selected_tickets=" + selected_tickets
            };

            $.ajax({
                type: "POST",
                url: api_link,
                data: parameters,
                async: false,
                dataType: "json",
                success: function (response)
                { insert_tecket_order_success(t, response) },
                error: insert_tecket_order_error

            });
        }
        else if (selected_tickets == "")
        {
            $("#error_ticket").text("Choose ticket to buy.");
            $("#loading").hide();
        }
        else if (money_selected >= 501)
        {
            $("#error_ticket").text("The total amount must not be more than $500");
            $("#loading").hide();
        }
    }
    catch (ex)
    {
        //$("#loading").hide();
        //send_error_fun("video_tickets.js",
        //    arguments.callee.toString().match(/function ([^\(]+)/)[1],
        //    ex, error_info + "&video_guid=" + video_guid);
    }
}

function insert_tecket_order_success(t, response)
{
    try
    {
        if (response != null && response != "")
        {
            t.setState({ ticket_order_guid: response }, () =>
            {
                if (t.state.paymentInfo.type === 1)
                {
                    get_paypal_url(t);
                }
                else
                {
                    buy_download_video_with_creditcard_for_mrl_payment(t);
                }
            });

        }
    }
    catch (ex)
    {
        //$("#loading").hide();
        //send_error_fun("video_tickets.js",
        //    arguments.callee.toString().match(/function ([^\(]+)/)[1],
        //    ex, error_info + "&selected_tickets=" + selected_tickets);
    }
}

function insert_tecket_order_error(ex)
{
    //$("#loading").hide();
    //send_error_fun("video_tickets.js",
    //    arguments.callee.toString().match(/function ([^\(]+)/)[1],
    //    ex, error_info + "&selected_tickets=" + selected_tickets);

}

function get_paypal_url(t)
{
    var api_link = "/api/HData/get_paypal_url/data";

    $.ajax({
        type: "POST",
        url: api_link,
        async: false,
        contentType: 'application/json',
        dataType: "text",
        success: function (response)
        { get_paypal_url_success(t, response); },
        error: get_paypal_url_error
    });
}
function get_paypal_url_success(t, response)
{
    if (response !== "")
    {
        window.location.href = response + "vg=" + t.props.videoData.videoGuid + "&vt=" + t.props.videoData.videoType + "&tog=" + t.state.ticket_order_guid
            + "&ch=" + t.props.videoData.channelGuid
    }
}
function get_paypal_url_error(ex)
{

}

export function apply_token(t, video_info_)
{

    var token = t.state.videoData.video_token;
    video_guid = t.state.videoData.videoGuid;
    video_info = video_info_;
    try
    {
        t.setState({ blocking: true }, () =>
        {
            if (token != "")
            {
                var api_link = localStorage.getItem("api_url") + ("check_PayPerView_Token");
                var parameters = {
                    token: token,
                    video_guid: video_guid,
                    account_guid: dv_account_guid,
                    error_info: error_info + "&token=" + token
                };

                $.ajax({
                    type: "POST",
                    url: api_link,
                    data: parameters,
                    async: true,
                    dataType: "json",
                    success: function (response)
                    { apply_token_success(t, response); },
                    error: apply_token_error

                });
            }
            else
            {
                t.setState({ blocking: false }, () => { t.showToast("Please enter ticket number", "error") })
                //$("#error_ticket").text("Please enter ticket no.");
            }
        })

    }
    catch (ex)
    {
        //send_error_fun("video_tickets.js",
        //    arguments.callee.toString().match(/function ([^\(]+)/)[1],
        //    ex, error_info + "&token=" + token);
        //$("#loading").hide();
    }
}
function apply_token_success(t, response)
{
    try
    {
        if (response != null && response != "")
        {
            if (response == "not found")
            {
                t.setState(prevState => ({
                    videoData: {
                        ...prevState.videoData,
                        token_status: "Invalid token",
                    }
                    , showTicketPopup: true,
                }), () =>
                {
                    //    load_tickets(t);
                })

            }
            else if (response == "viewers limit")
            {
                t.setState(prevState => ({
                    videoData: {
                        ...prevState.videoData,
                        token_status: "Viewers limit",
                    },
                    showTicketPopup: true,
                }), () =>
                {
                    //load_tickets(t);
                })

            }
            else if (response == "expired")
            {
                t.setState(prevState => ({
                    videoData: {
                        ...prevState.videoData,
                        token_status: "Expired ticket number",
                    },
                    showTicketPopup: true,
                }), () =>
                {
                    //    load_tickets(t);
                })
            }
            else
            {
                var token_info = response.split('_');
                var duration = token_info[2];
                duration = duration.split(' ');
                var duration_value = parseInt(duration[0]);
                var duration_unit = duration[1];
                token_expire_time = new Date();

                if (duration_unit == "Minute")
                {
                    token_expire_time.setMinutes(token_expire_time.getMinutes() + duration_value);
                }
                else if (duration_unit == "Hour")
                {
                    token_expire_time.setHours(token_expire_time.getHours() + duration_value);
                }
                else if (duration_unit == "Day")
                {
                    token_expire_time.setDate(token_expire_time.getDate() + duration_value);
                }
                else if (duration_unit == "Month")
                {
                    token_expire_time.setMonth(token_expire_time.getMonth() + duration_value);
                }


                // load video and response is token guid
                valid_token = "true";

                token_guid = token_info[0];
                ticket_expire_date = token_info[1];

                if (navigator.userAgent.toLowerCase().indexOf('chrome') > -1 && ticket_expire_date.indexOf('T') > -1)
                {
                    ticket_expire_date = ticket_expire_date.replace('T', ' ');
                }
                ticket_expire_date = new Date(ticket_expire_date);

                var time_country_zone = -(ticket_expire_date.getTimezoneOffset() / 60);
                var hours_plus_time_country_zone = (ticket_expire_date).setHours((ticket_expire_date).getHours() + time_country_zone);

                // add viewer to this token current viewers
                add_token_viewer(t, token_guid);
            }


        }
        else
        {
            t.setState(prevState => ({
                videoData: {
                    ...prevState.videoData,
                    token_status: "Invalid token",
                },
                showTicketPopup: true,
                blocking: false,
            }));
        }
    }
    catch (ex)
    {
        //send_error_fun("video_tickets.js",
        //    arguments.callee.toString().match(/function ([^\(]+)/)[1],
        //    ex, error_info + "&token=" + $('#token_text').val().trim());
        //$("#loading").hide();
    }
}

function apply_token_error(ex)
{

    //send_error_fun("video_tickets.js",
    //    arguments.callee.toString().match(/function ([^\(]+)/)[1],
    //    ex, error_info + "&token=" + $('#token_text').val().trim());
    //$("#loading").hide();
}

function add_token_viewer(t, token_guid)
{
    try
    {
        visitor_ip = t.state.videoData.visitor_ip;

        if (token_guid != "")
        {

            var expire_time = convert_expiration_date_to_utc(token_expire_time);
            var api_link = localStorage.getItem("api_url") + ("add_PayPerView_Token_viewer");
            var parameters = {
                token_guid: token_guid,
                viewer_ip: visitor_ip,
                expire_date: expire_time,
                account_guid: dv_account_guid,
                error_info: error_info + "&token_guid=" + token_guid
            };

            $.ajax({
                type: "POST",
                url: api_link,
                data: parameters,
                async: false,
                dataType: "json",
                success: function (response)
                { add_token_viewer_success(t, response) },
                error: function (response)
                { add_token_viewer_error(t, response) }

            });
        }
    }
    catch (ex)
    {
        //send_error_fun("video_tickets.js",
        //    arguments.callee.toString().match(/function ([^\(]+)/)[1],
        //    ex, error_info + "&token_guid=" + token_guid);
        //$("#loading").hide();
    }
}
function add_token_viewer_success(t, response)
{
    try
    {

        if (response != null)
        {
            t.setState(prevState => ({
                videoData: {
                    ...prevState.videoData,
                    token_status: "valid",
                },
                showTicketPopup: true,
                blocking: false,
            }))

            visitor_token = response;
            ticket_used = "true";

            // read all passwords cookie
            video_guid = t.state.videoData.videoGuid;
            var old_cookie = globalUtils.getCookie(video_guid);

            if (old_cookie == null)
            {
                // create cookie to save flag for ticket
                document.cookie = video_guid + "=" + token_guid + "_" + ticket_expire_date + "_" + visitor_token + "_" + token_expire_time
            }

            // added correctly
            if (video_info === undefined)
            {
                PlayerUtils.documnetReady(t);

            }
            else
            {
                PlayerUtils.check_video_password(t, video_info, visitor_token, ticket_used, valid_token);
            }
        }
        else
        {
            t.setState(prevState => ({
                videoData: {
                    ...prevState.videoData,
                    token_status: "Error occured",
                },
                showTicketPopup: true,
                blocking: false,
            }), () => { t.showToast("Error occured please contact admin", "error"); });
        }
    }
    catch (ex)
    {
        t.setState(prevState => ({
            videoData: {
                ...prevState.videoData,
                token_status: "Error occured",
            },
            showTicketPopup: true,
            blocking: false,
        }), () => { t.showToast("Error occured please contact admin", "error"); });


        globalUtils.send_error_fun("video_tickets.js",
            "add_token_viewer_success",
            ex, error_info + "&token_guid=" + token_guid);
    }
}
function add_token_viewer_error(t, ex)
{
    t.setState(prevState => ({
        videoData: {
            ...prevState.videoData,
            token_status: "Error occured",
        },
        showTicketPopup: true,
        blocking: false,
    }), () => { t.showToast("Error occured please contact admin", "error"); });

    globalUtils.send_error_fun("video_tickets.js",
        "add_token_viewer_error",
        ex, error_info + "&token_guid=" + token_guid);

}

function convert_expiration_date_to_utc(expiration_date)
{
    try
    {
        var expiration_date_ = new Date(expiration_date);
        var utc_expiration_date = new Date(expiration_date_.getUTCFullYear(), expiration_date_.getUTCMonth(), expiration_date_.getUTCDate(),
            expiration_date_.getUTCHours(), expiration_date_.getUTCMinutes(), expiration_date_.getUTCSeconds(), expiration_date_.getUTCMilliseconds());

        var day = utc_expiration_date.getDate();
        var month = utc_expiration_date.getMonth() + 1;
        var year = utc_expiration_date.getFullYear();
        var hour = utc_expiration_date.getHours();
        var minutes = utc_expiration_date.getMinutes();
        var secondes = utc_expiration_date.getSeconds();
        return month + "/" + day + "/" + year + " " + hour + ":" + minutes + ":" + secondes;
    }
    catch (ex)
    {
        //send_error_fun("video_tickets.js",
        //    arguments.callee.toString().match(/function ([^\(]+)/)[1],
        //    ex, error_info + "&expiration_date=" + expiration_date);
    }
}

export function buy_download_video_with_creditcard_for_mrl_payment(t)
{
    t.setState({ showDownloadPopup: false, blocking: true }, () =>
    {
        var api_link = "/api/HData/buy_download_video_with_creditcard_for_mrl_payment/data";
        var card_info = {
            card_number: t.state.card_info.card_number,
            card_expiration_year: t.state.card_info.card_expiration_year,
            card_expiration_month: t.state.card_info.card_expiration_month,
            card_verfication_no: t.state.card_info.card_verfication_no,
            card_type: t.state.card_info.card_type,
            card_first_name: t.state.card_info.card_first_name,
            card_last_name: t.state.card_info.card_last_name,
            card_address: t.state.card_info.card_address,
            card_country: "US",
            card_city: t.state.card_info.card_city,
            card_state: t.state.card_info.card_state,
            card_ZIP_code: t.state.card_info.card_ZIP_code,
            //ticket_order_guid: t.state.ticket_order_guid,
            vod_guid: t.state.videoData.videoGuid,
            vod_type: t.state.videoData.videoType,
            channel_guid: t.state.videoData.channelGuid,
            total_money: t.state.downloadVideoPrice,
            user_email: t.state.buy_download_video_email

        };
        $.ajax({
            type: "POST",
            url: api_link,
            async: true,
            contentType: 'application/json',
            data: JSON.stringify(card_info),
            dataType: "text",
            success: function (response)
            {
                buy_download_video_with_creditcard_for_mrl_payment_success(t, response);
            },
            error: function (ex)
            {
                buy_download_video_with_creditcard_for_mrl_payment_error(t, ex)
            }
        });
    });
}
function buy_download_video_with_creditcard_for_mrl_payment_success(t, response)
{
    if (response !== "" && response !== "false")
    {

        t.setState({ paymentInfo: null, selectedTicket: null }, () =>
        {
            insert_new_video_download_payment(t, response)
        })

    }
    else
    {
        t.toggleBlocking(false);
        t.showToast("Error ocuured please contact admin", "error");
    }
}
function buy_download_video_with_creditcard_for_mrl_payment_error(t, ex)
{
    t.toggleBlocking(false);
    t.showToast("Error ocuured please contact admin", "error");
}


export function buy_download_video_with_creditcard(t)
{
    t.setState({ showDownloadPopup: false, blocking: true }, () =>
    {
        var api_link = "/api/HData/buy_download_video_with_creditcard/data";
        var card_info = {
            card_number: t.state.card_info.card_number,
            card_expiration_year: t.state.card_info.card_expiration_year,
            card_expiration_month: t.state.card_info.card_expiration_month,
            card_verfication_no: t.state.card_info.card_verfication_no,
            card_type: t.state.card_info.card_type,
            card_first_name: t.state.card_info.card_first_name,
            card_last_name: t.state.card_info.card_last_name,
            card_address: t.state.card_info.card_address,
            card_country: "US",
            card_city: t.state.card_info.card_city,
            card_state: t.state.card_info.card_state,
            card_ZIP_code: t.state.card_info.card_ZIP_code,
            //ticket_order_guid: t.state.ticket_order_guid,
            vod_guid: t.state.videoData.videoGuid,
            vod_type: t.state.videoData.videoType,
            channel_guid: t.state.videoData.channelGuid,
            total_money: t.state.downloadVideoPrice,
            user_email: t.state.buy_download_video_email,
            payment_id_for_download_videos: t.state.videoData.payment_id_for_download_videos,

        };
        $.ajax({
            type: "POST",
            url: api_link,
            async: true,
            contentType: 'application/json',
            data: JSON.stringify(card_info),
            dataType: "text",
            success: function (response)
            {
                buy_ticket_by_credit_success(t, response);
            },
            error: function (ex)
            {
                buy_ticket_by_credit_error(t, ex)
            }
        });
    });
}
function buy_ticket_by_credit_success(t, response)
{
    if (response !== "" && response !== "false")
    {

        t.setState({ paymentInfo: null, selectedTicket: null }, () =>
        {
            insert_new_video_download_payment(t, response)
        })

    }
    else
    {
        t.toggleBlocking(false);
        t.showToast("Error ocuured please contact admin", "error");
    }
}
function buy_ticket_by_credit_error(t, ex)
{
    t.toggleBlocking(false);
    t.showToast("Error ocuured please contact admin", "error");
}
export function insert_new_video_download_payment(t, transaction_number)
{
    t.toggleBlocking(true);
    var download_url = t.state.videoData.video_url;
    download_url = download_url.replace("player_handler", "download_handler");
    if (t.state.videoData.channelGuid)
    {
        download_url = download_url + "&trn=" + transaction_number + "&ch=" + t.state.videoData.channelGuid
    }
    else
    {
        download_url = download_url + "&trn=" + transaction_number

    }
    var buy_download_video_email = t.state.buy_download_video_email;
    if (globalUtils.getParameterByName("em") && globalUtils.getParameterByName("dvt"))
    {
        buy_download_video_email = globalUtils.getParameterByName("em");
    }
    var api_link = localStorage.getItem("api_url") + "insert_new_video_download_payment";
    var parameters = {
        transaction_no: transaction_number,
        vod_guid: t.state.videoData.videoGuid,
        download_url: download_url,
        user_email: buy_download_video_email,
        video_title: t.state.videoData.video_title
    };
    
    var url = window.location.href.split('?')[0] + "?vg=" + t.state.videoData.videoGuid + "&vt=" + t.state.videoData.videoType;
    window.history.replaceState({}, '', url);

    $.ajax({
        type: "POST",
        url: api_link,
        data: parameters,
        async: false,
        dataType: "json",
        success: function (response)
        {
            insert_new_video_download_payment_success(t, response, transaction_number);
        },
        error: function (ex)
        {
            insert_new_video_download_payment_error(t, ex)
        }
    });
}
function insert_new_video_download_payment_success(t, response, transaction_number)
{
    
    if (response)
    {
        var download_url = t.state.videoData.video_url;
        download_url = download_url.replace("player_handler", "download_handler");
        if (t.state.videoData.channelGuid)
        {
            window.location = download_url + "&trn=" + transaction_number + "&ch=" + t.state.videoData.channelGuid;
        }
        else
        {
            window.location = download_url + "&trn=" + transaction_number;

        }

    }
    t.setState({ showDownloadPopup: false, blocking: false, downloadVideoPaymentSuccess: true },);
}
function insert_new_video_download_payment_error(t, ex)
{
    debugger
    t.setState({ blocking: false });
}
export function load_ticket_order_info(t)
{
    var order_guid = globalUtils.getParameterByName("og");
    var video_guid = globalUtils.getParameterByName("vg");
    var video_type = globalUtils.getParameterByName("vt");
    var transaction_id = globalUtils.getParameterByName("td");
    if (order_guid == null || order_guid == "")
    {
        t.setState(prevState => ({
            videoData: {
                ...prevState.videoData,
                token_status: "Invalid ticket",
            }
            , showTicketPopup: true,
        }), () =>
        {
            //    load_tickets(t);
        })
    }
    else
    {
        var api_link = "/api/HData/load_ticket_order_info/data";
        var parameters = {
            order_guid: order_guid,
            transaction_id: transaction_id,
            video_guid: video_guid,
            video_type: video_type,
        }
        $.ajax({
            type: "POST",
            url: api_link,
            async: false,
            contentType: 'application/json',
            data: JSON.stringify(parameters),
            dataType: "json",
            success: function (response)
            { load_ticket_order_info_success(t, response); },
            error: load_ticket_order_info_error
        });
    }
}
function load_ticket_order_info_success(t, response)
{
    try
    {
        if (response != null && response.length > 0)
        {
            var list_tickets = [];
            var tickets_list = response;
            var ticket_item = {};
            var transaction_id = globalUtils.getParameterByName("td");
            var order_guid = globalUtils.getParameterByName("og");
            for (var i = 0; i < tickets_list.length; i++)
            {
                if (tickets_list[i].duration === 24)
                {
                    ticket_item = {
                        description: "24 Hours for this content",
                        id: tickets_list[i].ppv_id,
                        token: tickets_list[i].token,
                        token_guid: tickets_list[i].token_guid,
                        transaction_id: transaction_id,
                        order_guid: order_guid,
                    };
                }
                else
                {
                    ticket_item = {
                        description: "1 Month for all content of this acount",
                        id: tickets_list[i].ppv_id,
                        token: tickets_list[i].token,
                        token_guid: tickets_list[i].token_guid,
                        transaction_id: transaction_id,
                        order_guid: order_guid,
                    };
                }
                list_tickets.push(ticket_item);

            }
            t.setState({ new_ticket_info: list_tickets })
        }
    }
    catch (ex)
    {

    }
}
function load_ticket_order_info_error(ex)
{

}

export function send_email(t)
{
    if (t.state.email !== "" && t.state.email !== undefined && t.state.email !== null)
    {
        //t.props.toggleBlocking(true);
        var order_guid = globalUtils.getParameterByName("og");
        var video_guid = globalUtils.getParameterByName("vg");
        var video_type = globalUtils.getParameterByName("vt");
        var channel_guid = globalUtils.getParameterByName("ch");
        var transaction_id = globalUtils.getParameterByName("td");
        var api_link = "/api/HData/send_ticket_email/data";
        var parameters = {
            order_guid: order_guid,
            transaction_id: transaction_id,
            video_guid: video_guid,
            video_type: video_type,
            user_email: t.state.email,
            channel_guid: channel_guid

        }
        $.ajax({
            type: "POST",
            url: api_link,
            async: true,
            contentType: 'application/json',
            data: JSON.stringify(parameters),
            dataType: "text",
            success: function (response)
            { send_email_success(t, response); },
            error: function (response)
            { send_email_error(t, response) }
        });
    }
    else
    {
        t.showToast("Please enter your email", "error");
    }

}
function send_email_success(t, response)
{
    //t.props.toggleBlocking(false);
    if (response === "true")
    {
        t.setState({ showEmailPopup: false }, () =>
        {
            t.showToast("Email sent to you", "success");
        })
    }
    else
    {
        t.setState({ showEmailPopup: true }, () =>
        {
            t.showToast("Error occured please try again", "error");
        })
    }
}

function send_email_error(t, ex)
{
    //t.props.toggleBlocking(true);
    t.setState({ showEmailPopup: true }, () =>
    {
        t.showToast("Error occured please try again", "error");
    })
}
export function check_puerchase_by_email(t)
{
    var api_link = localStorage.getItem("api_url") + "get_transaction_number_by_vod_and_email";
    var parameters = {
        vod_guid: t.state.videoData.videoGuid,
        user_email: t.state.buy_download_video_email
    };
    $.ajax({
        type: "POST",
        url: api_link,
        data: parameters,
        async: false,
        dataType: "json",
        success: function (response)
        {
            check_puerchase_by_email_success(t, response);
        },
        error: function (ex)
        {
            check_puerchase_by_email_error(t, ex)
        }
    });
}
function check_puerchase_by_email_success(t, response)
{
    if (response && response !== "0")
    {
        var download_url = t.state.videoData.video_url;
        download_url = download_url.replace("player_handler", "download_handler");
        if (t.state.videoData.channelGuid)
        {
            window.location = download_url + "&trn=" + response + "&ch=" + t.state.videoData.channelGuid
        }
        else
        {
            window.location = download_url + "&trn=" + response

        }
        t.setState({ showDownloadPopup: false });
    }
    else if (response && response === "0")
    {
        t.setState({ download_video_error: "You used all your attempts to download this video please buy new token" })
    }
}
function check_puerchase_by_email_error(t, ex)
{

}